import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { UserProvider, useUser } from 'src/UserContext';

const Home = lazy(() => import('./Common/Home'));
const Login = lazy(() => import('./Login/Login.js'));
const Display = lazy(() => import('./UserProfile/Display.js'));
const ValidatePage = lazy(() => import('./ValidateLogin/ValidatePage'));
const ForgotPassword = lazy(() => import('./RegistryForm/ForgotPassword'));
const GenerateCode = lazy(() => import('./RegistryForm/GenerateCode'));
const NotFound = lazy(() => import('./Common/NotFound'));

const RouteFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <span className="spinner w-8 h-8 border-2 border-brand-teal border-t-transparent" />
  </div>
);

function App() {
  const { isSignedIn } = useUser();

  return (
    <div className="App">
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route
            path='/'
            element={isSignedIn ? <Display /> : <Home />}
          />
          <Route
            path="/profile"
            element={isSignedIn ? <Display /> : <Login />}
          />
          <Route path='/signin' element={<Login />} />
          <Route path='/validatePage' element={<ValidatePage />} />

          <Route path='/forgotPassword' element={<ForgotPassword />} />
          <Route path='/generateCode' element={<GenerateCode />} />

          <Route path='*' element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}

function AppWithProvider() {
  return (
    <UserProvider>
      <App />
    </UserProvider>
  );
}

export default AppWithProvider;
